export default {
  title: {
    en: 'We like your style!',
  },
  text: {
    en: 'Now share your thoughts with the Scentbird community. And help us recommend you better scents in future. '
      + 'It takes <strong>less than 20 seconds!</strong>',
  },
  step: {
    en: '{step} of {stepCount}',
  },
  skip: {
    en: 'Skip personalisation',
  },
  titleByType: {
    default: {
      en: 'How would you describe this scent?',
    },
    STYLE: {
      en: 'What kind of a mood does this scent give off?',
    },
    OCCASION: {
      en: 'Where would you wear this fragrance?',
    },
    SEASON: {
      en: 'Which season best complements this scent?',
    },
    ATTRIBUTE: {
      en: 'Do any of these descriptors match the fragrance?',
    },
    COMPLEXITY: {
      en: 'How would you describe the intensity of this scent?',
    },
  },
}
